import React from 'react';
import SEO from '../components/SEO';
import Hero from '../components/Hero';
import Services from '../components/Services';
import Testimonials from '../components/Testimonials';
import Stats from '../components/Stats';
import SecurityTypes from '../components/SecurityTypes';
import FAQ from '../components/FAQ';
import VideoSection from '../components/VideoSection';
import ContactForm from '../components/ContactForm';
import Blog from '../components/Blog';
import StatesCoverage from '../components/StatesCoverage';

const HomePage = () => {
  return (
    <>
      <SEO 
        title="Professional Security Guards Nationwide"
        description="Armed Security Service provides professional armed and unarmed security guards nationwide. 24/7 protection services for businesses, events, and residential properties. Licensed, bonded & insured."
        keywords="armed security guards, unarmed security, security services, fire watch, event security, commercial security, nationwide security, 24/7 security"
      />
      <Hero />
      <Services />
      <Testimonials />
      <Stats />
      <SecurityTypes />
      <FAQ />
      <VideoSection />
      <ContactForm />
      <Blog />
      <StatesCoverage />
    </>
  );
};

export default HomePage;